import { render, staticRenderFns } from "./ViewServiceBillItems.vue?vue&type=template&id=d06fd4f2"
import script from "./ViewServiceBillItems.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewServiceBillItems.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports